
import Vue from 'vue'
import Component from 'vue-class-component'
import {Watch} from 'vue-property-decorator'
import NameUtil from '@/utils/NameUtil'
import StoreDefineLogin from '@/define/store/user/login'
import LoginService from '@/service/user/LoginService'

@Component
export default class App extends Vue {
  mounted() {
    this.redirectWithLoginState(LoginService.getLoginState())
  }

  get loginState(): boolean {
    return this.$store.getters[NameUtil.CSCK(StoreDefineLogin.GET_LOGIN_STATE)]
  }

  @Watch('loginState')
  onLoginStateChange(loginState: boolean) {
    this.redirectWithLoginState(loginState)
  }

  redirectWithLoginState(loginState: boolean) {
    this.$router.replace(loginState ? '/main' : '/login')
  }
}
